import Vue from 'vue'

const originTranslate = (value) => {
  let title = ''
  let $t = Vue.i18n.translate
  switch (value) {
    case 'I':
      title = $t('modalDetalhesLanc.tabItegrations.labels.origemInterno')
      break
    case 'E':
      title = $t('modalDetalhesLanc.tabItegrations.labels.origemExterno')
      break
    default :
      title = value
      break
  }
  return title
}

const typeTranslate = (value) => {
  let title = ''
  let $t = Vue.i18n.translate
  switch (value) {
    case 'C':
      title = $t('categoria.labels.credito')
      break
    case 'D':
      title = $t('categoria.labels.debito')
      break
    default :
      title = value
      break
  }
  return title
}

const conciliationStatusTranslate = (value) => {
  let title = ''
  let $t = Vue.i18n.translate
  switch (value) {
    case 'C':
      title = $t('statusConciliacao.conciliado')
      break
    case 'M':
      title = $t('statusConciliacao.conciliadoManualmente')
      break
    case 'D':
      title = $t('statusConciliacao.divergente')
      break
    case 'N':
      title = $t('statusConciliacao.naoAplicavel')
      break
    case 'A':
      title = $t('statusConciliacao.aberto')
      break
    default :
      title = value
      break
  }
  return title
}

const taskBondTypeTranslate = (value) => {
  let title = ''
  let $t = Vue.i18n.translate
  switch (value) {
    case 'CL':
      title = $t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoCL')
      break
    case 'MF':
      title = $t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoMF')
      break
    default :
      title = value
      break
  }
  return title
}

const taskStatusesTranslate = (value) => {
  let title = ''
  let $t = Vue.i18n.translate
  switch (value) {
    case 0:
      title = $t('tarefaEmMassa.tarefaStatuses.pendente')
      break
    case 10:
      title = $t('tarefaEmMassa.tarefaStatuses.emAndamento')
      break
    case 20:
      title = $t('tarefaEmMassa.tarefaStatuses.aguardando')
      break
    case 90:
      title = $t('tarefaEmMassa.tarefaStatuses.concluido')
      break
    case 99:
      title = $t('tarefaEmMassa.tarefaStatuses.cancelada')
      break
    default :
      title = value
      break
  }
  return title
}
export {
  typeTranslate,
  conciliationStatusTranslate,
  originTranslate,
  taskBondTypeTranslate,
  taskStatusesTranslate
}



// WEBPACK FOOTER //
// ./client/utils/statusesTranslator.js